import { Formik, FormikProps } from 'formik';
import { Guid } from 'guid-typescript';
import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { Notification } from '../../components/notification/main';
import { IAction, IAppState } from '../../models/action/core';
import { IAddQuestion, IAddQuestionState, IValidationChoice } from '../../models/components/add-question';
import { getValidation } from '../../models/validations/questionBank-validation';
import CAddActivityFooter from '../../components/add-activity/footer';
import * as Actions from '../../store/actions/question';
import { SelectAsync, SelectNoneAsync } from '../../components/input/select/main';
import { IQuestionData } from '../../models/components/questions';
import { QuestionType } from '../../models/enums/QuestionType';
import OpenEnded from './questionType/open-ended';
import Choice from './questionType/choice';
import Ordering from './questionType/ordering';
import Matching from './questionType/matching';
import { ActivityType, ActivityTypeEnums } from '../../models/enums/ActivityType';
import { spawn } from 'child_process';
import Switch from 'react-switch';
import Tooltip from '../../components/tooltip/main';

let _common: Common;
const T = Translator.create();
const _logger = Log.create('QuestionBank Add Page');
const spinnerId = 'addQuestionLoading';
let _fileInputkey: string = '';
export class AddQuestion extends React.Component<IAddQuestion, IAddQuestionState> {
    _activitySettingTab = [
        'masterCourseName',
        'questionTypeValidation',
        'questionText'
    ];

    constructor(props: any) {
        super(props);
        _common = new Common();
        _fileInputkey = Guid.create().toString();
        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            currentTab: '_activitySettingTab',
            fileInputKey: Guid.create().toString(),
            photoUploadKey: Guid.create().toString(),
            isAddQuestionAndCreateNew: false,
            isDisabled: false,
            choices: { singleChoice: [], multiChoice: [], ordering: [], matching: [] },
            isLoadingProcess: false
        };
    }

    onSubmit = (FormikValues: IQuestionData) => {
        this.setState({ isDisabled: true, isLoadingProcess: true });
        const values: IQuestionData = JSON.parse(JSON.stringify(FormikValues));
        values.fileUploadKey = _fileInputkey;
        this.props.dispatch(Actions.AddQuestion(values, this.callBackFunction, spinnerId, 'get'));
    };

    callBackFunction = (value: any) => {

        if (!value) {
            this.setState({ isLoadingProcess: false });
            return;
        }

        this.setState({ isDisabled: false });

        if (value) {
            if (this.state.isAddQuestionAndCreateNew) {
                _fileInputkey = Guid.create().toString();
                this.setState({ isAddQuestionAndCreateNew: false, isLoadingProcess: false });
            } else {
                this.props.setCloseModal();
                this.setState({ isLoadingProcess: false });
            }
        }
    };

   
    validateTabAndChange = async (values: FormikProps<IQuestionData>, onClickNext: boolean, nextTab?: string, completeForm?: boolean, isClear?: boolean) => {
        const validations = await values.validateForm().then((result: any) => result);
        let isCompleted: boolean = true;
        let blankStatus:boolean =  false;

        if(_common.removeHtmlTags((values.values.questionText), true) === ''){
            Notification.setNotification(
                'error',
                T.t('r_questionBank_add_questionText'),
                'topRight'
            );
            isCompleted = false;
        }

        if (values.values.questionType === -99) {
            Notification.setNotification(
                'error',
                T.t('r_questionBank_add_questionType'),
                'topRight'
            );
        }

        if (values.values.questionType === QuestionType.Ordering && values.values.choices && values.values.choices.length < 2) {
            Notification.setNotification(
                'error',
                T.t('r_questionBank_add_questionChoice_min'),
                'topRight'
            );
            isCompleted = false;
        }

        if (values.values.questionType === QuestionType.Matching && values.values.choices && values.values.choices.length < 4) {
            Notification.setNotification(
                'error',
                T.t('r_questionBank_add_questionChoice_min'),
                'topRight'
            );
            isCompleted = false;
        }

        if (values.values.questionType !== QuestionType.OpenEnded && (!values.values.choices || !values.values.choices.length)) {
            Notification.setNotification(
                'error',
                T.t('r_add_options'),
                'topRight'
            );
            isCompleted = false;
        }

        if (values.values.choices && values.values.choices.length > 0) {
            if (values.values.questionChoiceType) {
                const s = values.values.choices.filter(x => !x.isPreviewFile);
                if (s.length > 0 ) {
                    Notification.setNotification(
                        'error',
                        T.t('r_questionBank_add_questionChoice'),
                        'topRight'
                    );
                    isCompleted = false;
                    blankStatus = true;

                }
            } else {
                const RegExpHtmlTags = /(<([^>]+)>)/ig;
                const RegExpBase64 = /<img([^>]+)src="(data:image\/[^;]+;base64[^"]+)"/i;
                const RegExpWhiteChar = /\s+/g;
                const s = values.values.choices.filter(x => x.choiceText.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '') === '' || !x.choiceText.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '').length);
                const y = values.values.choices.filter(x =>  _common.removeHtmlTags(x.choiceText, true) == '');
                if (s.length > 0 || y.length > 0) {
                    Notification.setNotification(
                        'error',
                        T.t('r_questionBank_add_questionChoice'),
                        'topRight'
                    );
                    blankStatus = true;

                    isCompleted = false;
                }

                const breakException = {};
                if (values.values.questionType !== QuestionType.Matching) {
                    if(blankStatus === false){
                    try {
                        values.values.choices.forEach(choice => {
                            const otherChoices = values.values.choices.filter(inChoice => inChoice.displayOrder !== choice.displayOrder);
                            const duplicate = otherChoices.findIndex(o => o.choiceText.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '').replace(RegExpWhiteChar, '') === choice.choiceText.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '').replace(RegExpWhiteChar, ''));
                           
                           
                            if (duplicate !== -1) {
                                Notification.setNotification(
                                    'error',
                                    T.t('r_questionBank_add_questionChoice_duplicate'),
                                    'topRight'
                                );
                                isCompleted = false;
                                throw breakException;
                            }
                        });
                    } catch (e) {
                        if (e !== breakException) throw e;
                    }
                } 
                } else {
                    if(blankStatus === false){

                    try {
                        const choices: IValidationChoice[] = [];
                        values.values.choices.filter(c => c.side === 0).forEach(choice => {
                            const rightChoice = values.values.choices.find(c => c.side === 1 && c.sortOrder.toString() === choice.optionText);
                            choices.push({ displayOrder: choice.displayOrder, leftChoiceText: choice.choiceText, rightChoicetext: rightChoice!.choiceText });
                        });
                        choices.forEach(choice => {
                            const otherChoices = choices.filter(inChoice => inChoice.displayOrder !== choice.displayOrder);
                            const duplicate = otherChoices.findIndex(o => o.leftChoiceText.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '').replace(RegExpWhiteChar, '') === choice.leftChoiceText.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '').replace(RegExpWhiteChar, '') &&
                                o.rightChoicetext.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '').replace(RegExpWhiteChar, '') === choice.rightChoicetext.replace(RegExpBase64, 'image').replace(RegExpHtmlTags, '').replace(RegExpWhiteChar, ''));
                            if (duplicate !== -1) {
                                Notification.setNotification(
                                    'error',
                                    T.t('r_questionBank_add_questionChoice_duplicate'),
                                    'topRight'
                                );
                                isCompleted = false;
                                throw breakException;
                            }
                        });
                    } catch (e) {
                        if (e !== breakException) throw e;
                    }
                }
                }
            }

            if ((values.values.questionType === QuestionType.MultipleSingle || values.values.questionType === QuestionType.MultipleMultiple) && values.values.choices.findIndex(x => x.isCorrect) === -1) {
                Notification.setNotification(
                    'error',
                    T.t('r_questionBank_add_correct_choice'),
                    'topRight'
                );
                isCompleted = false;
            }

            if ((values.values.questionType === QuestionType.MultipleMultiple) &&  values.values.choices.filter(x => x.isCorrect).length<2) {
                Notification.setNotification(
                    'error',
                    T.t('r_questionBank_add_correct_questionChoice_min'),
                    'topRight'
                );
                isCompleted = false;
            }
        }

        Object.keys(validations).forEach((validationKey: string) => {
            if (this._activitySettingTab.find(key => key === validationKey)) {
                Notification.setNotification(
                    'error',
                    validations[validationKey],
                    'topRight'
                );
                isCompleted = false;
            }
        });

        if (completeForm) {
            if (this.props.onCompleteValidateForm) {
                if (!this.props.onCompleteValidateForm(validations, undefined, this.props.isProjectSubActivity)) {
                    isCompleted = false;
                }
            }

            if (isCompleted) {
                await values.validateForm().then((result: any) => result);
                values.submitForm();
            } else {
                this.setState({ isAddQuestionAndCreateNew: false });
            }
        }

        if (isClear && isCompleted) {
            setTimeout(() => {
                values.resetForm();
                values.setFieldValue('questionText', '');
                values.setFieldValue('questionComment', '');
                values.setFieldValue('questionType', values.values.questionType);
                values.setFieldValue('masterCourseIds', values.values.masterCourseIds);
                values.setFieldValue('termIds', values.values.termIds);
                values.setFieldValue('courseIds', values.values.courseIds);
                values.setFieldValue('categoryIds', values.values.categoryIds);
                values.setFieldValue('questionDifficulty', values.values.questionDifficulty);
                values.setFieldValue('isHtmlQuestion', values.values.isHtmlQuestion);
                values.setFieldValue('isPublicQuestion', values.values.isPublicQuestion);
                values.setFieldValue('topicIds', values.values.topicIds);
                values.setFieldValue('keywordIds', values.values.keywordIds);
                values.setFieldValue('questionChoiceType', values.values.questionChoiceType);
                values.setFieldValue('choices', []);
            }, 1000);
        }
    };

    getValidation = (formik: IQuestionData) => {
        if (formik.isExamQuestion) {
            const updateActivityQuestionType = this.props.questionData?.questionType
            return getValidation({
                initialQuestionType: updateActivityQuestionType,
                isExamQuestion: formik.isExamQuestion
            });
        }
        if (
            this.props.coursePageclassInformation &&
            this.props.coursePageclassInformation.isWeekly === true &&
            this.props.coursePageclassInformation.startDate &&
            this.props.coursePageclassInformation.endDate
        ) {
            return getValidation({
                isProjectSubActivity: this.props.isProjectSubActivity,
                startDate: this.props.coursePageclassInformation.startDate,
                endDate: this.props.coursePageclassInformation.endDate,
                dateFormat: _common.findDateFormat(this.props.userPreferences!),
                termWeeks: this.props.courseContentTermWeeks,
                isUpdate: this.props.updateQuestionId ? true : false,
            });
        } else {
            return getValidation({ isProjectSubActivity: this.props.isProjectSubActivity });
        }
    };

    setCloseModal = () => {
        this.props.dispatch(Actions.setQuestionDataDefault());
        this.props.setCloseModal();
        this.setState({ choices: { singleChoice: [], multiChoice: [], ordering: [], matching: [] } });
    };

    public onChangeSelectCondition(selectValue: any, formik: FormikProps<IQuestionData>) {
        if (selectValue) {
            _fileInputkey = Guid.create().toString();
            const _prevQuestionType = formik.values.questionType;

            formik.setFieldValue('questionType', selectValue.value);

            if (_prevQuestionType !== -99 && _prevQuestionType !== selectValue.value) {
                switch (_prevQuestionType) {
                    case QuestionType.MultipleMultiple:
                        this.state.choices.multiChoice = formik.values.choices;
                        break;
                    case QuestionType.MultipleSingle:
                        this.state.choices.singleChoice = formik.values.choices;
                        break;
                    case QuestionType.Ordering:
                        this.state.choices.ordering = formik.values.choices;
                        break;
                    case QuestionType.Matching:
                        this.state.choices.matching = formik.values.choices;
                        break;
                    default:
                        break;
                }

                switch (selectValue.value) {
                    case QuestionType.MultipleMultiple:
                        formik.setFieldValue('choices', this.state.choices.multiChoice);
                        break;
                    case QuestionType.MultipleSingle:
                        formik.setFieldValue('choices', this.state.choices.singleChoice);
                        break;
                    case QuestionType.Ordering:
                        formik.setFieldValue('choices', this.state.choices.ordering);
                        break;
                    case QuestionType.Matching:
                        formik.setFieldValue('choices', this.state.choices.matching);
                        break;
                    default:
                        break;
                }
            }
        }
    }
    public onChangeChangeQuestionDif(selectValue: any, formik: FormikProps<IQuestionData>) {
        if (selectValue) {
            formik.setFieldValue('questionDifficulty', selectValue);
        }
    }

    public onChangeChangeQuestionIsPublic(selectValue: boolean, formik: FormikProps<IQuestionData>) {
        formik.setFieldValue('isPublicQuestion', selectValue);
    }

    public addQuestionButtonClick = () => {
        this.setState({ isAddQuestionAndCreateNew: true });
    };

    public localization = (result: any) => {
        if (result) {
            const rText = result.match(/# *([^#]+)#/);
            if (rText) {
                result = result.replace(rText[0], T.t(rText[1]));
            }
        }

        return result;
    };

    public renderQuestion = (questionType: QuestionType, formik: FormikProps<IQuestionData>,) => {
        switch (questionType) {
            case QuestionType.OpenEnded:
                return <OpenEnded formik={formik} fileInputKey={_fileInputkey} />;
            case QuestionType.MultipleSingle:
                return <Choice formik={formik} isMulti={false} fileInputKey={_fileInputkey} />;
            case QuestionType.MultipleMultiple:
                return <Choice formik={formik} isMulti={true} fileInputKey={_fileInputkey} />;
            case QuestionType.Ordering:
                return <Ordering formik={formik} fileInputKey={_fileInputkey} />;
            case QuestionType.Matching:
                return <Matching formik={formik} fileInputKey={_fileInputkey} />;
            default:
                return '';
        }
    }

    public render() {
        const initialQuestionDatas: IQuestionData = this.props.questionData!;
        return (
            <Modal
                isOpen={this.props.isModalOpen}
                toggle={this.setCloseModal}
                modalClassName={'add-activity-modal modal-from-right slideInRight show animated add-question-modal'}
                fade={true}
                style={{ display: 'block', animationDuration: '0.5s' }}
                backdrop={'static'}
            >
                <div className="modal-dialog" role="document" style={{ width: '54vw' }}>
                    {/* {(this.props.updateQuestionId && !this.props.QuestionDatas!.results![0].questionId) || !this.props.updateQuestionId ? ( */}
                    <div className="modal-content">
                        <Formik validationSchema={this.getValidation(initialQuestionDatas)} initialValues={initialQuestionDatas} onSubmit={this.onSubmit}>
                            {formik => {
                                return (
                                    <form onSubmit={formik.handleSubmit} role="form">
                                        <div className=" modal-header d-flex justify-content-start">

                                            <h5 className="modal-title d-flex align-items-center">
                                                <i className="material-icons mr-2">{_common.GetMaterialActivityIcons(ActivityType.Assignment)}</i>
                                                {this.props.updateQuestionId ? T.t('r_update_question') : T.t('r_new_question')}
                                            </h5>
                                            <button
                                                onClick={this.setCloseModal}
                                                type="button"
                                                className="close"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <i style={{ color: '#000' }} className="material-icons">
                                                    close
                                                </i>
                                                <span>{T.t('r_gen_close')}</span>
                                            </button>

                                        </div>
                                        <div className="modal-body p-0">
                                            <div className="tab-content" id="tabContent">
                                                <div
                                                    className={'tab-pane fade show active question-tab-pane'}
                                                    id="select-classes"
                                                    role="tabpanel"
                                                    aria-labelledby="select-class-tab"
                                                >
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="form-input form-group date-picker">
                                                                <SelectAsync
                                                                    isMulti={false}
                                                                    isSearchable={true}
                                                                    requestType={'post'}
                                                                    parameter={{ SearchedText: '', SelectedIds: formik.values.masterCourseIds ? [formik.values.masterCourseIds] : [], Take: 5 }}
                                                                    placeHolder={T.t('r_gen_questionBank_master_course') + " *"}
                                                                    url={'api/question/getMasterCourses'}
                                                                    closeMenuOnScroll={false}
                                                                    closeMenuOnSelect={true}
                                                                    name={'masterCourseIds'}
                                                                    value={formik.values.masterCourseIds}
                                                                    onChange={formik.handleChange}
                                                                    setFieldValue={formik.setFieldValue}
                                                                    errors={formik.errors.masterCourseIds}
                                                                    touched={formik.touched.masterCourseIds}
                                                                    isTouched={formik.setFieldTouched}
                                                                    hasLocalization={true}
                                                                    setFieldOnlyValue={true}
                                                                    isClearable={true}
                                                                    setSelectValue={this.props.updateQuestionId && formik.values.masterCourseIds ? [formik.values.masterCourseIds] : []}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col">
                                                            <div className="form-input form-group date-picker">
                                                                <SelectAsync
                                                                    isMulti={false}
                                                                    isSearchable={true}
                                                                    requestType={'post'}
                                                                    parameter={{ SearchedText: '', CourseIds: formik.values.courseIds ? [formik.values.courseIds] : [], GetTypes: 'Course', Skip: 0, Take: 10 }}
                                                                    placeHolder={T.t('r_activity_type_Course')}
                                                                    url={'api/organization/search'}
                                                                    closeMenuOnScroll={false}
                                                                    closeMenuOnSelect={true}
                                                                    name={'courseIds'}
                                                                    value={formik.values.courseIds}
                                                                    onChange={formik.handleChange}
                                                                    setFieldValue={formik.setFieldValue}
                                                                    errors={formik.errors.courseIds}
                                                                    touched={formik.touched.courseIds}
                                                                    isTouched={formik.setFieldTouched}
                                                                    hasLocalization={true}
                                                                    setFieldOnlyValue={true}
                                                                    isClearable={true}
                                                                    setSelectValue={this.props.updateQuestionId && formik.values.courseIds ? [formik.values.courseIds] : []}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col">
                                                            <div className="form-input form-group date-picker">
                                                                <SelectAsync
                                                                    isMulti={false}
                                                                    isSearchable={true}
                                                                    requestType={'post'}
                                                                    parameter={{ SearchedText: '', SelectedIds: formik.values.termIds ? [formik.values.termIds] : [], Take: 5 }}
                                                                    placeHolder={T.t('r_gen_questionBank_questionTerm')}
                                                                    url={'api/question/getTerms'}
                                                                    closeMenuOnScroll={false}
                                                                    closeMenuOnSelect={true}
                                                                    name={'termIds'}
                                                                    value={formik.values.termIds}
                                                                    onChange={formik.handleChange}
                                                                    setFieldValue={formik.setFieldValue}
                                                                    errors={formik.errors.termIds}
                                                                    touched={formik.touched.termIds}
                                                                    isTouched={formik.setFieldTouched}
                                                                    hasLocalization={true}
                                                                    setFieldOnlyValue={true}
                                                                    isClearable={true}
                                                                    setSelectValue={this.props.updateQuestionId && formik.values.termIds ? [formik.values.termIds] : []}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="form-input form-group date-picker">
                                                                <SelectAsync
                                                                    isMulti={true}
                                                                    isSearchable={true}
                                                                    requestType={'post'}
                                                                    parameter={{ SearchedText: '', SelectedIds: formik.values.topicIds ? formik.values.topicIds : [], Take: 5 }}
                                                                    placeHolder={T.t('r_gen_questionBank_questionTopic')}
                                                                    url={'api/question/getTopics'}
                                                                    closeMenuOnScroll={false}
                                                                    closeMenuOnSelect={true}
                                                                    name={'topicIds'}
                                                                    value={formik.values.topicIds}
                                                                    onChange={formik.handleChange}
                                                                    setFieldValue={formik.setFieldValue}
                                                                    errors={formik.errors.topicIds}
                                                                    touched={formik.touched.topicIds}
                                                                    isTouched={formik.setFieldTouched}
                                                                    hasLocalization={true}
                                                                    isClearable={true}
                                                                    insertUrl={'addTopic'}
                                                                    infoMessage={'r_tag_topic_add_success'}
                                                                    setFieldOnlyValue={true}
                                                                    setSelectValue={this.props.updateQuestionId ? formik.values.topicIds : []}
                                                                    canAddable={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="form-input form-group date-picker">
                                                                <SelectAsync
                                                                    isMulti={true}
                                                                    isSearchable={true}
                                                                    requestType={'post'}
                                                                    parameter={{ SearchedText: '', SelectedIds: formik.values.categoryIds ? formik.values.categoryIds : [], Take: 5 }}
                                                                    placeHolder={T.t('r_add_exam_category')}
                                                                    url={'api/question/getCategories'}
                                                                    closeMenuOnScroll={false}
                                                                    closeMenuOnSelect={true}
                                                                    name={'categoryIds'}
                                                                    value={formik.values.categoryIds}
                                                                    onChange={formik.handleChange}
                                                                    setFieldValue={formik.setFieldValue}
                                                                    errors={formik.errors.categoryIds}
                                                                    touched={formik.touched.categoryIds}
                                                                    isTouched={formik.setFieldTouched}
                                                                    hasLocalization={true}
                                                                    isClearable={true}
                                                                    insertUrl={'addCategory'}
                                                                    infoMessage={'r_tag_category_add_success'}
                                                                    setFieldOnlyValue={true}
                                                                    setSelectValue={this.props.updateQuestionId ? formik.values.categoryIds : []}
                                                                    canAddable={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="form-input form-group date-picker">
                                                                <SelectAsync
                                                                    isMulti={true}
                                                                    isSearchable={true}
                                                                    requestType={'post'}
                                                                    parameter={{ SearchedText: '', SelectedIds: formik.values.keywordIds ? formik.values.keywordIds : [], Take: 5 }}
                                                                    placeHolder={T.t('r_gen_questionBank_questionKeyword')}
                                                                    url={'api/question/getKeyword'}
                                                                    closeMenuOnScroll={false}
                                                                    closeMenuOnSelect={true}
                                                                    name={'keywordIds'}
                                                                    value={formik.values.keywordIds}
                                                                    onChange={formik.handleChange}
                                                                    setFieldValue={formik.setFieldValue}
                                                                    errors={formik.errors.keywordIds}
                                                                    touched={formik.touched.keywordIds}
                                                                    isTouched={formik.setFieldTouched}
                                                                    hasLocalization={true}
                                                                    isClearable={true}
                                                                    insertUrl={'addKeyword'}
                                                                    infoMessage={'r_tag_keyword_add_success'}
                                                                    setFieldOnlyValue={true}
                                                                    setSelectValue={this.props.updateQuestionId ? formik.values.keywordIds : []}
                                                                    canAddable={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <React.Fragment>
                                                                <span className="new-subtitle">{T.t('r_gen_questionBank_isHtml')}</span>
                                                                <div className="">
                                                                    <div className="col-md-12">
                                                                        <div style={{ float: 'inline-start', marginTop: 2 }}>
                                                                            <Switch
                                                                                id={'check-isHtmlQuestion'}
                                                                                name={'isHtmlQuestion'}
                                                                                // tslint:disable-next-line:jsx-no-lambda
                                                                                onChange={(e: any) => formik.setFieldValue('isHtmlQuestion', !formik.values.isHtmlQuestion)}
                                                                                defaultChecked={true}
                                                                                checked={formik.values.isHtmlQuestion}
                                                                                onColor="#319b6b"
                                                                                handleDiameter={18}
                                                                                uncheckedIcon={false}
                                                                                checkedIcon={false}
                                                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                                                height={20}
                                                                                width={38}
                                                                                className="react-switch"
                                                                            />
                                                                        </div>
                                                                        <label htmlFor="check-isHtmlQuestion" style={{ marginInlineStart: 5, marginTop: 2 }}>
                                                                            {formik.values.isHtmlQuestion ? T.t('r_yes') : T.t('r_no')}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 col-12">
                                                            <span className="new-subtitle">{T.t('r_gen_questionBank_dificulty')}</span>
                                                            <div className="row">
                                                                <div className="col-md-12 difficulties pr-0 pl-0">
                                                                    {
                                                                        this.props.questionDiffuculties ? (
                                                                            this.props.questionDiffuculties.map((diff, index) => (
                                                                                <div key={index} className="control_group survey_choose mr-4">
                                                                                    <span
                                                                                        className="control control--radio"
                                                                                        onClick={this.onChangeChangeQuestionDif.bind(this, diff.value, formik)}
                                                                                    >
                                                                                        {T.t(this.localization(diff.label))}
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            name={'questionDifficulty'}
                                                                                            value={diff.value}
                                                                                            id={T.t(this.localization(diff.label))}
                                                                                            checked={formik.values.questionDifficulty === diff.value ? true : false}
                                                                                            style={{ borderRadius: 100 }}
                                                                                        />
                                                                                        <div className="control__indicator" />
                                                                                    </span>
                                                                                </div>
                                                                            ))
                                                                        ) : ''
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 col-12">
                                                            <span className="new-subtitle">{T.t('r_question_questionauthtitle')}</span>
                                                            <div className="row">
                                                                <div className="col-md-12 difficulties">
                                                                    {
                                                                        <div key={0} className="control_group survey_choose mr-4" style={{ justifyContent: 'start' }}>
                                                                            <button
                                                                                type='button'
                                                                                style={{ border: 'none', background: 'none' }}
                                                                                className="control control--radio"
                                                                                onClick={() => this.onChangeChangeQuestionIsPublic(false, formik)}>
                                                                                {T.t(this.localization('r_question_q_is_mine'))}
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name={'isPublicQuestion'}
                                                                                    value={"false"}
                                                                                    id={T.t(this.localization('r_question_q_is_mine'))}
                                                                                    checked={!formik.values.isPublicQuestion}
                                                                                    style={{ borderRadius: 100 }}
                                                                                />
                                                                                <div className="control__indicator" />
                                                                            </button>
                                                                        </div>
                                                                    }
                                                                    {
                                                                        <div key={1} className="control_group survey_choose mr-4" style={{ justifyContent: 'left' }}>
                                                                            <button
                                                                                type='button'
                                                                                style={{ border: 'none', background: 'none' }}
                                                                                className="control control--radio"
                                                                                onClick={() => this.onChangeChangeQuestionIsPublic(true, formik)}>
                                                                                {T.t(this.localization('r_question_q_is_public'))}
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name={'isPublicQuestion'}
                                                                                    value={"true"}
                                                                                    id={T.t(this.localization('r_question_q_is_public'))}
                                                                                    checked={formik.values.isPublicQuestion}
                                                                                    style={{ borderRadius: 100 }}
                                                                                />
                                                                                <div className="control__indicator" />
                                                                            </button>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row align-items-center">
                                                        <div className="col-md-6 col-12">
                                                            <span className="new-subtitle">{T.t('r_gen_questionBank_questionType')} <span className="ml-1" style={{ color: '#dc5050' }}>* </span></span>
                                                            <div className="row" style={{ marginTop: '5px !important' }}>
                                                                <div className="col">
                                                                    <SelectNoneAsync
                                                                        name={'questionType'}
                                                                        touched={formik.touched.questionType}
                                                                        errors={formik.errors.questionType}
                                                                        setFieldValue={formik.setFieldValue}
                                                                        setOptions={[
                                                                            { value: QuestionType.MultipleSingle, label: T.t('r_gen_questionBank_questionType_multiple_single') },
                                                                            { value: QuestionType.MultipleMultiple, label: T.t('r_gen_questionBank_questionType_multiple_multiple') },
                                                                            { value: QuestionType.OpenEnded, label: T.t('r_gen_questionBank_questionType_open') },
                                                                            { value: QuestionType.Ordering, label: T.t('r_gen_questionBank_questionType_ordering') },
                                                                            { value: QuestionType.Matching, label: T.t('r_gen_questionBank_questionType_matching') }
                                                                        ]}
                                                                        // tslint:disable-next-line:jsx-no-lambda
                                                                        onChange={(e: any) => this.onChangeSelectCondition(e, formik)}
                                                                        isTouched={formik.setFieldTouched}
                                                                        placeHolder={T.t('r_make_select')}
                                                                        setSelectValue={this.props.updateQuestionId ? [formik.values.questionType] : []}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={'col-md-6 col-12 '.concat(formik.values.questionType == 1 || formik.values.questionType == 4 ? 'question_explain' : 'd-none')} >
                                                            <div>
                                                                {
                                                                    formik.values.questionType == 0 ? '' :
                                                                        formik.values.questionType == 1 ?
                                                                            <>
                                                                                <Tooltip data={T.t('r_match_question_explain')} position='top'>
                                                                                    <img src={_common.GetDefaultIcons('info')} alt="" />
                                                                                    <div className="course-tooltip"
                                                                                        style={{ lineHeight: 'inherit', minWidth: '330px', zIndex: 1000, paddingTop: 7, left: -20, bottom: 30 }}
                                                                                    >
                                                                                        <table>
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td width="30%" className='text-align-start' style={{ color: 'white' }}>
                                                                                                        {T.t('r_match_question_explain')}
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            </>
                                                                            :
                                                                            formik.values.questionType == 2 ? '' :
                                                                                formik.values.questionType == 3 ? '' :
                                                                                    formik.values.questionType == 4 ?
                                                                                        <>
                                                                                            <Tooltip data={T.t('r_order_question_explain')} position='top'>
                                                                                                <img src={_common.GetDefaultIcons('info')} alt="" />
                                                                                            </Tooltip>
                                                                                        </> :
                                                                                        ''
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        {this.renderQuestion(formik.values.questionType, formik)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <CAddActivityFooter
                                            currentTab={this.state.currentTab}
                                            formikProps={formik}
                                            spinnerId={spinnerId}
                                            validateTabAndChange={this.validateTabAndChange}
                                            isProjectSubActivity={this.props.isProjectSubActivity}
                                            setCloseModal={this.setCloseModal}
                                            addQuestion={this.props.updateQuestionId ? false : true}
                                            addQuestionButtonClick={this.addQuestionButtonClick}
                                            isDisabled={this.state.isDisabled}
                                            isLoadingProcess={this.state.isLoadingProcess}
                                        />
                                    </form>
                                );
                            }}
                        </Formik>
                    </div>
                    {/* ) : null}{' '} */}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddQuestion): IAddQuestion => {
    if (!state) {
        return ownProps;
    }

    const newProps: IAddQuestion = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        questionData: state.question.QuestionData,
        questionDatas: state.question.QuestionDatas,
        questionDiffuculties: state.question.questionDifficulties
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.profile.userPreferences === prev.profile.userPreferences &&
        next.question.QuestionData === prev.question.QuestionData &&
        next.question.QuestionDatas === prev.question.QuestionDatas &&
        next.question.questionDifficulties === prev.question.questionDifficulties;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CAddQuestion = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(AddQuestion);

export default CAddQuestion;
